import React from 'react';
import { useSelector } from 'react-redux';

// Own constants/actions/components
import ButtonFloat from 'components/button-float';
import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import DetailExperienceContainer from 'containers/detail-experience';
import { items } from 'services/selectors/shopping-cart';

const DetailExpPage = () => {
  const itemsCart = useSelector(items);

  return (
    <div>
      <ButtonFloat number={itemsCart.length} />
      <HeaderContainer />
      <DetailExperienceContainer />
      <FooterContainer />
    </div>
  );
};

export default DetailExpPage;
